<!--
 * @Author: Latte
 * @Date: 2021-09-15 09:59:49
 * @LAstEditors: Latte
 * @LastEditTime: 2022-01-26 12:01:28
 * @FilePath: \Siui.Cloud.Medical.Web\src\components\FileManagement\File\category.vue
-->
<template>
  <div class="app-container">
    <div class="topbar">
      <div align="left"><p style="line-height:2em;color: gray"><i class="el-icon-warning-outline" style="color: red"></i>产品资料按分类类别进行管理，上传产品资料时需配置资料所属的<a style="color: blue">分类</a>和<a style="color: blue">属性</a>。</p></div>
      <div align="right">
        <el-button
                type="primary"
                size="small"
                style="margin-top: 15px"
                @click="conditionDialogVisible=true"
        >
          新增分类
        </el-button>
      </div>
    </div>
    <el-table
      :data="tableData"
      v-loading="loading"
      border
      style="width: 100%; margin-bottom: 20px"
    >
      <el-table-column
              label="排序"
              align="center"
              prop="sort"
              width="50"
      ></el-table-column>
      <el-table-column
        label="分类名称"
        align="center"
        prop="showName"
        width="100px"
      ></el-table-column>
      <el-table-column label="属性" prop="childConditionList" align="center">
        <template slot-scope="scope">
          <p>
            <el-tag
                    type="primary"
                    size="medium"
                    v-for="item in scope.row.childConditionList"
                    :key="item.label"
                    style="margin-right: 10px; margin-bottom: 10px"
            >
              {{ item.showName }}
            </el-tag>
            <i @click="goSetCondition(scope.row)" class="el-icon-setting" style="float: right;font-size: 23px; "></i>
          </p>
        </template>
      </el-table-column>
<!--      <el-table-column label="属性配置" width="100" align="center">-->
<!--        <template slot-scope="scope">-->
<!--          <el-button size="small" @click.stop="goSetCondition(scope.row)"-->
<!--            >详细配置</el-button-->
<!--          >-->
<!--        </template>-->
<!--      </el-table-column>-->
      <el-table-column label="启用筛选条件" width="105" align="center">
        <template slot-scope="scope">
          <el-switch
                  active-color="#03be56"
                  @change="toggleShowStatus(scope.row)"
                  :active-value="true"
                  :inactive-value="false"
                  v-model="scope.row.isEnable"
          >
          </el-switch
          ></template>
      </el-table-column>
      <el-table-column label="操作" width="150" align="center">
        <template slot-scope="scope">
          <el-button
                  type="primary"
                  size="small"
                  @click.stop="handleEdit(scope.row)"
          >编辑</el-button
          >
          <el-button
            type="danger"
            size="small"
            @click.stop="handleDelete(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>


    <!-- 新增类别对话框 -->
    <el-dialog
            title="新增分类类别"
            :modal="false"
            :visible.sync="conditionDialogVisible"
            width="50%"
    >
      <el-form ref="formRef" :model="conditionModel" label-width="150px">
        <el-form-item label="类别名称" prop="showName" >
          <el-input
                  v-model="conditionModel.showName"
                  placeholder="请输入名称"
                  style="width:252px"
          ></el-input>
        </el-form-item>
        <el-form-item label="俄语版名称" prop="showName" >
          <el-input
                  v-model="conditionModel.showNameRussian"
                  placeholder="请输入名称"
                  style="width:252px"
          ></el-input>
        </el-form-item>
        <el-form-item label="是否启用为筛选条件" prop="enable">
          <el-radio-group v-model="conditionModel.isEnable" >
            <el-radio :label="true">是</el-radio>
            <el-radio :label="false">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="排序">
          <el-input-number size="small" v-model="conditionModel.sort" :min="1"></el-input-number>
          <br>温馨提示：排序值决定分类在管理页顶部分类导航的显示顺序。<br>数值越小排序越靠前。
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click.stop="cancelAddCondition()">取 消</el-button>
        <el-button type="primary" size="small" @click.stop="addCondition()">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 编辑类别对话框 -->
    <el-dialog
            title="编辑分类类别"
            :modal="false"
            :visible.sync="editDialogVisible"
            width="30%"
    >
      <el-form ref="formRef" :model="editConditionModel" label-width="100px">
        <el-form-item label="类别名称" prop="showName">
          <el-input
                  v-model="editConditionModel.showName"
                  placeholder="请输入名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="俄语版名称" prop="showNameRussian">
          <el-input
                  v-model="editConditionModel.showNameRussian"
                  placeholder="请输入名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="排序">
          <el-input-number
                  size="small"
                  v-model="editConditionModel.sort"
                  :min="1"
          ></el-input-number>
        </el-form-item>温馨提示：<br>排序值决定分类在管理页顶部<br>分类导航的显示顺序。<br>数值越小排序越靠前。
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click.stop="cancelEditDialog()">取 消</el-button>
        <el-button type="primary" size="small" @click.stop="editCondition()">确 定</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import {
  getConditionList,
  addCondition,
  deleteCondition,
  updateCondition,
} from "@/api/system/CSDocument/file";

//数值比较，用于排序
function sortArr(attr) {
  return function(a,b) {
    return a[attr] - b[attr]
  }
}

export default {
  data() {
    return {
      loading: false,
      tableData: [],
      value1: true,
      value2: true,
      dialogVisible: false,
      conditionList: [], // 保存筛选条件
      editDialogVisible:false,
      conditionDialogVisible: false,
      editConditionModel:{
        csFileConditionID:"",
        showName:"",
        showNameRussian:"",
        isEnable:"",
        sort:"",
      },
      conditionModel: {
        type:0,
        level:0,
        parentID:0,
        isEnable:true,
        userDataType:2,
        fieldOp:"equal",
        fieldName:"dataType",
        showNameRussian:"",
        createUserID:"",
        showName:"",
        fieldValue:"",
        sort:"",
      },

    };
  },
  created() {
    this.refreshCurrentList();
  },
  methods: {

    refreshCurrentList() {
      this.getCategoriesList();
    },

    getCategoriesList() {
      let param={
        includeChild:1
      };
      this.loading = true;
      getConditionList(param).then((res) => {
        var tempList=[];
        var maxValue=0;
        var maxSort=0;
        if (res.data.length > 0) {
          for (var temp of res.data) {
            tempList.push(temp);
            if (temp.fieldValue > maxValue) {
              maxValue = temp.fieldValue;
            }
            if (temp.sort > maxSort) {
              maxSort = temp.sort;
            }
          }
        }
        this.tableData = tempList.sort(sortArr('sort'));
        this.conditionModel.fieldValue=parseInt(maxValue)+1;
        this.conditionModel.sort=parseInt(maxSort)+1;
        this.loading = false;
      });
    },

    /**
     * @description: 切换显示状态
     * @param {*} status
     * @return {*}
     */
    toggleShowStatus(row) {
      console.log("row", row);
      let params = {
        csFileConditionID: row.csFileConditionID,
        showName: row.showName,
        isEnable: row.isEnable,
      };
      console.log(params);
      updateCondition(params).then((res) => {
        console.log(" --------------------------");
        console.log("updateCondition - res", res);
        console.log(" --------------------------");
        this.$message({
          message: "修改成功",
          type: "success",
          duration: 1000,
        }).catch((error) => {
          if (row.enable === false) {
            row.enable = true;
          } else {
            row.enable = false;
          }
        });
      });
    },
    // 编辑操作对话框
    handleEdit(row){
      this.editDialogVisible=true;
      this.editConditionModel.csFileConditionID=row.csFileConditionID;
      this.editConditionModel.showName=row.showName;
      this.editConditionModel.showNameRussian=row.showNameRussian;
      this.editConditionModel.sort=row.sort;
      this.editConditionModel.isEnable=row.isEnable;
    },

    // 删除操作对话框
    handleDelete(row){
      let params = {
        csFileConditionID: row.csFileConditionID,
      };
      this.$confirm("您要删除此分类吗？", this.$t("tips"), {
        confirmButtonText: this.$t("yes"),
        cancelButtonText: this.$t("no"),
        type: "warning",
      })
              .then(() => {
                deleteCondition(params).then(() => {
                  this.$message({
                    message: "操作成功",
                    type: "success",
                  });
                  this.getCategoriesList();
                });
              })
              .catch(() => {
                this.$message("取消操作");
              });
    },
    // 跳转 筛选条件配置页面
    goSetCondition(row) {
      this.$router.push({
        path: `conditionDetail/${row.csFileConditionID}`,
        query: {
          csFileConditionID: row.csFileConditionID,
        },
      });
    },

    //取消添加分类对话框
    cancelAddCondition(){
      this.conditionDialogVisible=false;
      this.conditionModel.showName="";
      this.conditionModel.isEnable=true;
    },

    //新增一级分类
    addCondition(){
      let params={}
      params.fieldName=this.conditionModel.fieldName;
      params.fieldOp=this.conditionModel.fieldOp;
      params.fieldValue=this.conditionModel.fieldValue;
      params.isEnable=this.conditionModel.enable;
      params.level=this.conditionModel.level;
      params.parentID = this.conditionModel.parentID;
      params.showName=this.conditionModel.showName;
      params.showNameRussian=this.conditionModel.showNameRussian;
      params.sort=this.conditionModel.sort;
      params.type=this.conditionModel.type;
      params.userDataType=this.conditionModel.userDataType;
      addCondition(params).then((res)=>{
        console.log(res);
        if(res.code===200){
          this.$message({
            message: "操作成功",
            type: "success",
          });
        }
        else if(res.code===403){
          this.$message({
            message: res.message,
            type: "Warning",
          });
        }
        this.conditionDialogVisible = false;
        this.getCategoriesList();
      });
    },

    //更新筛选条件
    editCondition(){
      let params={
        csFileConditionID:this.editConditionModel.csFileConditionID,
        showName:this.editConditionModel.showName,
        showNameRussian:this.editConditionModel.showNameRussian,
        sort:this.editConditionModel.sort,
      };
      updateCondition(params).then((res)=>{
        console.log(res);
        if(res.code===200){
          this.$message({
            message: "操作成功",
            type: "success",
          });
        }
        this.editDialogVisible = false;
        this.getCategoriesList();
      });
    },

    cancelEditDialog(){
      this.editDialogVisible = false;
      this.editConditionModel.csFileConditionID="";
      this.editConditionModel.showName="";
      this.editConditionModel.showNameRussian="";
      this.editConditionModel.isEnable="";
      this.editConditionModel.sort="";
    },
  },
};
</script>

<style>
</style>